function addTitleReviewsIframe() {
  const parent = $(".js-embedsocial-reviews-iframe-wrap");
  if (parent.length > 0) {
    setTimeout(function () {
      parent.each(function () {
        $(this).find("iframe").attr("title", "embedsocial reviews iframe");
      });
    }, 3500);
  }
}

export default addTitleReviewsIframe;
